import { IconProps } from "@/src/sb/business-layer/types"
import React from "react"

const MetaDataIcon = ({ width, height, size }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width ?? size ?? 3}
    height={height ?? size ?? 3}
    viewBox="0 0 2 3"
    fill="none"
  >
    <circle cx="1" cy="1.5" r="1" fill="currentColor" />
  </svg>
)

export default MetaDataIcon
